"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Make sure the URL is valid.
 *
 * We make sure to dedupe some URL parts:
 * - The provided `staticPath` is generally suffixed with a `/`.
 * - Some legacy components are still prefixing assets with `/static`.
 */
var sanitizeUrl = function (url) {
    return url
        .replace(/(\/){2,}/g, '$1')
        .replace(/(https?:\/)/g, '$1/')
        .replace(/(\/static){2,}/g, '$1');
};
/**
 * Check if a given URL should remain unprefixed.
 */
var shouldRemainUnprefixed = function (url) {
    if (url === void 0) { url = ''; }
    return ['http', 'data:', '/media/storage', 'blob:'].some(function (beginning) { return (url || '').indexOf(beginning) === 0; });
};
var buildStaticAssetUrl = function (url, staticPath) {
    return shouldRemainUnprefixed(url) ? url : sanitizeUrl(staticPath + "/" + url);
};
exports.default = buildStaticAssetUrl;
